/*
  Quanti scroll reveal.
  Sections with the class "animation-section" fade (and lift 20px) into view. The animation
  itself is plain CSS (quanti.css), so anything on the first screen paints straight away
  without waiting for this script. This script only holds back sections that start below the
  fold (class "q-reveal-pending") and releases them the first time they come near the
  viewport, which replays the same CSS animation. Containers marked "q-reveal-children"
  animate their children instead of moving the whole section.
  Respects prefers-reduced-motion and is disabled in the theme editor.
  An IntersectionObserver does the work (no forced layout on load); a light scroll check
  backs it up so content can never stay hidden if observer callbacks are delayed.
*/
(() => {
  const SELECTOR = '.animation-section';
  const REVEALED = 'is-revealed';
  const PENDING = 'q-reveal-pending';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  const seen = new WeakSet();
  let observer = null;

  const reveal = (el) => {
    el.classList.remove(PENDING);
    el.classList.add(REVEALED);
    pending.delete(el);
    if (observer) observer.unobserve(el);
  };

  const inView = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight + 50 && rect.bottom > -50;
  };

  const check = () => pending.forEach((el) => inView(el) && reveal(el));

  let scheduled = false;
  const onScroll = () => {
    if (scheduled || !pending.size) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      check();
    }, 100);
  };

  const onIntersect = (entries) =>
    entries.forEach((entry) => {
      const el = entry.target;
      if (entry.isIntersecting) {
        reveal(el);
      } else if (!seen.has(el)) {
        // First report and it's off screen: hold it until it scrolls into view.
        el.classList.add(PENDING);
        pending.add(el);
      }
      seen.add(el);
    });

  const init = (root = document) => {
    const sections =
      root.matches && root.matches(SELECTOR) ? [root] : root.querySelectorAll(`${SELECTOR}:not(.${REVEALED})`);
    const instant =
      reduceMotion.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window);
    sections.forEach((section) => {
      if (instant) return reveal(section);
      observer = observer || new IntersectionObserver(onIntersect, { threshold: 0, rootMargin: '50px 0px' });
      observer.observe(section);
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
